import '../stylesheets/affiliate.scss';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

require('@rails/ujs').start();
require('chartkick');

const application = Application.start();
const context = require.context('../src/controllers', true, /\.js$/);
const context_components = require.context(
  '../../components',
  true,
  /_controller.js$/
);
application.load(
  definitionsFromContext(context).concat(
    definitionsFromContext(context_components)
  )
);

// Submit settings form when toggling settings
$('html').on('change', '.settings-toggle', function () {
  this.closest('form').requestSubmit();
});

$('select#user_locale').closest('form').on('ajax:success', function() {
  window.location.reload();
})

$('html').on('change', 'select#user_locale', function () {
  this.closest('form').requestSubmit();
});
